/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_Close_Aria_LabelInputs */

const en_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close position modal`)
};

const fr_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue de position`)
};

const de_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal für geschlossene Position`)
};

const it_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi posizione modale`)
};

const ru_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модель закрытого положения`)
};

const es_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar posición modal`)
};

const zh_cn2_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭位置模式`)
};

const ja_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置モーダルを閉じる`)
};

const hi_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद स्थिति मॉडल`)
};

const pt_pt2_position_modal_close_aria_label = /** @type {(inputs: Position_Modal_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modal de posição fechada`)
};

/**
* | output |
* | --- |
* | "Close position modal" |
*
* @param {Position_Modal_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_close_aria_label = /** @type {((inputs?: Position_Modal_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_close_aria_label(inputs)
	if (locale === "de") return de_position_modal_close_aria_label(inputs)
	if (locale === "it") return it_position_modal_close_aria_label(inputs)
	if (locale === "ru") return ru_position_modal_close_aria_label(inputs)
	if (locale === "es") return es_position_modal_close_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_close_aria_label(inputs)
	if (locale === "ja") return ja_position_modal_close_aria_label(inputs)
	if (locale === "hi") return hi_position_modal_close_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_close_aria_label(inputs)
	return en_position_modal_close_aria_label(inputs)
});